package navigation.home.crm

import navigation.home.crm.contactorganization.ContactOrganizationScreenModel
import navigation.home.customfields.CustomFieldsScreenModel
import org.koin.core.module.dsl.factoryOf
import org.koin.dsl.module

val CRMUiModule
    get() =
        module {
            factoryOf(::CRMScreenModel)
            factoryOf(::ContactOrganizationScreenModel)
            factoryOf(::CustomFieldsScreenModel)
        }